import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import './styles.scss';
import {compose} from 'redux';
import {strings} from '../../../../../util/strings';
import colors from '../../../../../util/colors';
import * as fonts from '../../../../../util/fonts';
import {Icons} from '../../../../../util/icons';
import ModalTemplate from './../../../../../components/modal/index';
import Column from './../../../../../components/layout/Column';
import Row from './../../../../../components/layout/Row';
import AppButton from './../../../../../components/app-button/index';
import {addToGlobalStyles, addToWizard} from '../../../../../store/actions';
import Icon from './../../../../../components/icon/Icon';

interface SelectUsersPopupProps {
  //   user: any;
  //   addToGlobalStyles(value: any): void;
  //   selectedBu: any;
  //   labels: typeof strings.pt.preAuthorizations;
  show: boolean;
  setShowModal(value: any): void;
  //   addToWizard(value: any): void;
  onSubmit(value: any): void;
  onClose?(): void;
  labelsPermissions: typeof strings.pt.permissions;
  buStyles: any;
  overEighteen: any[];
  initialSelectedUsers: any[];
}

function SelectUsersPopup({
  //   user,
  //   addToGlobalStyles,
  //   selectedBu,
  //   labels,
  //   addToWizard,
  show,
  setShowModal,
  onSubmit,
  labelsPermissions,
  onClose,
  buStyles,
  overEighteen,
  initialSelectedUsers,
}: SelectUsersPopupProps) {
  const history = useHistory();

  const [selectedItems, setSelectedItems] = useState<any>([]);

  const [hover, setHover] = useState();

  useEffect(() => {
    setSelectedItems(initialSelectedUsers);
  }, [initialSelectedUsers]);

  const auxFinalValue = (value: string) => {
    if (selectedItems.find((el: any) => value === el)) {
      const newValue = selectedItems.filter((obj: any) => obj !== value);
      setSelectedItems(newValue);
      //setFinalValue('');
    } else {
      let aux = [...selectedItems];
      aux.push(value);
      setSelectedItems(aux);
      //setFinalValue(value);
    }
  };

  return (
    <Column
      className="pre-autorizacoes-modal-content p-5"
      style={!show ? {display: 'none'} : {}}>
      <ModalTemplate
        className="p-5"
        show={show}
        onHide={() => {
          if (onClose) {
            onClose();
          }
        }}
        cross={true}
        hideFooter={true}>
        <Column>
          <Row className="pre-autorizacoes-title-row">
            <p
              style={{...fonts.L, ...fonts.SemiBold, color: colors.black}}
              className="p-preautorizacoes">
              {labelsPermissions.permissions_authAllowedTo}
            </p>
          </Row>
          <Row className="pre-autorizacoes-table-row">
            <table
              className="table table-hover pl-3 pr-3"
              onMouseOut={() => setHover(undefined)}>
              <tbody>
                {overEighteen.map((elem: any) => (
                  <tr
                    key={elem.label}
                    id={elem.label}
                    onClick={(e) => {
                      auxFinalValue(elem.label);
                    }}
                    onMouseOver={() => {
                      setHover(elem.value);
                    }}
                    style={{
                      backgroundColor:
                        selectedItems.find((el: any) => el === elem.label) ||
                        elem.value === hover
                          ? (buStyles?.primaryColor || colors.blue)?.concat(
                              '1A'
                            )
                          : 'transparent',
                    }}>
                    <td align="left" id={elem.label}>
                      <p
                        id={elem.label}
                        style={{
                          ...fonts.MM,
                          ...fonts.Medium,
                          color: colors.black,
                        }}
                        className="p-preautorizacoes">
                        {elem.label}
                      </p>
                    </td>
                    <td className="pre-authorization-checkbox" id={elem.label}>
                      {selectedItems.find((el: any) => el === elem.label) ? (
                        <Icon
                          name={Icons.CHECK}
                          width="14"
                          height="19.44"
                          changeViewbox
                          viewBox={'0 0 24 24'}
                          color={colors.black}
                        />
                      ) : (
                        <div></div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Row>

          <Row>
            <AppButton
              className="pre-autorizacoes-buttons"
              style={{...fonts.M, color: colors.white}}
              onClick={() => {
                onSubmit(selectedItems);
                setShowModal(false);
              }}>
              {labelsPermissions.permissions_confirm}
            </AppButton>
          </Row>
        </Column>
      </ModalTemplate>
    </Column>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  globalStyles,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labelsPermissions: strings.value.pt.permissions,
  wizard: wizard.value,
  buStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(SelectUsersPopup)
);
